import React from "react";
import { useState } from "react";
import ImageUploader from "react-images-upload";
import { useDispatch, useSelector } from "react-redux";
import { displayError } from "../helpers";
import { resizeFile } from "../helpers/CropImage";
import { fundRaiserPageAction } from "../store/actions";
import { MixPanelTrackedLink } from "./MixPaneTrackedLink";
import { Textfield } from "./Textfield";

export function CommentBox() {
    const dispatch = useDispatch();

    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);
    const user = useSelector(state => state.authentication.user);

    const [state, setState] = useState({
        comment: "",
        images: [],
        uploadKey: 0
    });
    const [errorMessage, setErrorMessage] = useState(null);

    const updateState = (name, value) => {
        if (errorMessage)
            setErrorMessage(null)
        setState({
            ...state,
            [name]: value
        })
    }

    const submitUpdates = async () => {
        if (!state.comment)
            setErrorMessage("Comment is required")
        else {
            const formData = new FormData();
            formData.append('description_updates', state.comment);
            formData.append('fundraiser_page_id', pageDetails.id);
            formData.append('user_id', user.id);
            for (const file of state.images) {
                const image = await resizeFile(file);
                formData.append('images_updates[]', image);
            };
            await dispatch(fundRaiserPageAction.addUpdatesAsDescriptionOrImages(formData, pageDetails.id));
            
            setState({
                comment: "",
                images: [],
                uploadKey: state.uploadKey + 1
            })
        }
    }

    return <div className="update-sub-box">
        <Textfield
            id="comment"
            name="comment"
            label='Write your comment here *'
            onChange={e => updateState(e.target.name, e.target.value)}
            error={displayError(errorMessage)}
            helpertext={errorMessage}
            value={state.comment}
            sx={{
                marginTop: '10px'
            }}
            rows={6}
            multiline
            fullWidth
        />
        <div className="update-img-upl" style={{ marginTop: '20px' }}>
            <ImageUploader
                name="images"
                buttonText="Choose images"
                fileSizeError={'file size should be less than 5mb'}
                imgExtension={[".jpg", ".gif", ".png", ".jpeg"]}
                key={state.uploadKey}
                withPreview={true}
                withIcon={false}
                withLabel={false}
                maxFileSize={5242880}
                onChange={files => updateState('images', files)}
            />

            <div className='update-sub-act-btn'>
                <MixPanelTrackedLink
                    type="button"
                    label='Submit Updates'
                    context="Adding comment on fundraiser page"
                    variant="contained"
                    onClick={submitUpdates}
                >
                    Submit Updates
                </MixPanelTrackedLink>
            </div>
        </div>
    </div>
}